/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Cps_TitleInputs */



/**
* | output |
* | --- |
* | "Characters per second" |
*
* @param {Summary_Cps_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_cps_title = /** @type {((inputs?: Summary_Cps_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Cps_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caracteres par seconde")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeichen pro Sekunde")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caratteri al secondo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Символов в секунду")
	if (locale === "es") return /** @type {LocalizedString} */ ("Caracteres por segundo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每秒字符数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1秒あたりの文字数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्ण प्रति सेकंड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caracteres por segundo")
	return /** @type {LocalizedString} */ ("Characters per second")
});